import { render } from "./DashboardJobs.vue?vue&type=template&id=b5ef571a&scoped=true&ts=true"
import script from "./DashboardJobs.vue?vue&type=script&lang=ts"
export * from "./DashboardJobs.vue?vue&type=script&lang=ts"

import "./DashboardJobs.vue?vue&type=style&index=0&id=b5ef571a&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ef571a"]])

export default __exports__